
<div class="bg-login">
	<div class="container h-100">
	<div class="wrap text-center h-100 align-content-center">
		<div class="col-12 row m-0 p-0">
			<div class="col-3"></div>
			<div class="col-12 col-lg-6 bg-f-w justify-content-center z-100">
				<div class="col-12 m-0 row">
					<div class="col-3"></div>
					<div class="col-12 col-md-6 p-0 mt-4">
						<div class="col-12 text-center p-0 mt-4">
							<img src="../../assets/images/rekruu_logo.png" alt="" height="110" class="mx-auto">
							<h4 class="semiboldtextblue90024 mt-4">Tervetuloa</h4>
							<p class="normaltextblue90016 f-os mt-2">Syötä käyttäjätunnus ja salasana</p>
						</div>
					</div>
					<div class="col-3"></div>
		
				</div>
		
				<div class="col-12 p-0 row m-0">
					<div class="col-1"></div>
					<div class="col-12 col-md-10 p-0">
						<div class="col-12 p-0 ">
							<div class="col-12 login-form-bg">
								<div class="alert alert-warning mt-3 mb-3" id="login-err" style="display: none;" >
									<p class="body2b-b">Käyttäjätunnus tai salasana on väärin</p>
								</div>
								<div class="alert alert-danger" id="lock-err" style="display: none;" >
									<p class="body2b-b">Käyttäjätili lukittu 15min ajaksi</p>
								</div>
								<div id="loader" class="loader-container mt-4 mb-4" style="display:none">
									<div class="loader mx-auto"></div>
									<p class="body2b-b text-center mt-4 mb-4">Kirjaudutaan sisään...</p>
								</div>
								<form class="flex-row " id="login-form" [formGroup]="loginFormi"
								(ngSubmit)="renderReCaptch()">
								<!-- Sähköposti -->
								<div class="col-12 row m-0 pt-2">
									<div class="form-floating mb-2  col-12 col-md-12 p-0">
										<input type="email" placeholder="Sähköposti" formControlName="userName" id="userName" class="form-control" [class.invalid-input]="userName.errors && userName.touched" required>
										<label for="userName">Sähköposti</label>
									</div>
								</div>
								<!-- Salasana -->
								<div class="col-12 row m-0 pt-2">
								<div class="form-floating mb-2  col-12 col-md-12 p-0">
									<input type="password" placeholder="Salasana" formControlName="password" id="password" class="form-control" [class.invalid-input]="password.errors && password.touched" required>
									<label for="password">Salasana</label>
								</div>
							</div>
								<div class=" mx-auto mt-2">
									<div class="text-center" >
										<button #recaptcha [disabled]="loginFormi.invalid" class="btn btn-formed-main-blue w-100"   ><i class="fas fa-sign-in-alt me-2"></i>Kirjaudu</button>
									</div>
								</div>
							</form>
						
					</div>
						</div>
					</div>
					<div class="col-1"></div>
		
				</div>
		
				<div class="d-flex justify-content-center flex-row mb-4">
					<div class="link-container">
						<p class="mt-2  ">Unohditko salasanan? Uusi se 
							<a  routerLink="/{{businessID}}/forgot-password">tästä</a>
						</p>
		
					</div>
				</div>
			</div>
			<div class="col-3"></div>
		</div>

	</div>
	</div>

		<div class="bubbles">
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
			<div class="bubble"></div>
		  </div>
</div>

